'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// NOTE: Reimplementation of recompose's createHelper as it wasn't exposed :(
var createHelper = function createHelper(func, helperName) {
    var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (process.env.NODE_ENV !== 'production' && setDisplayName) {
        var wrapDisplayName = require('recompose').wrapDisplayName;

        if (noArgs) {
            return function (BaseComponent) {
                var Component = func(BaseComponent);
                Component.displayName = wrapDisplayName(BaseComponent, helperName);
                return Component;
            };
        }

        return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (args.length > func.length) {
                console.error('Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
            }

            return function (BaseComponent) {
                var Component = func.apply(undefined, args)(BaseComponent);
                Component.displayName = wrapDisplayName(BaseComponent, helperName);
                return Component;
            };
        };
    }

    return func;
};

exports.default = createHelper;


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteRecompose/createHelper.js
// module id = 2131
// module chunks = 0